'use client';

import { atom, useAtom } from 'jotai';
import LinkButton from '../../../../components/form/LinkButton/LinkButton';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import ModalBase from '../../../../components/ui/ModalBase/ModalBase';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryGoodsModalState } from '../../types';

const goodsModalAtom = atom<LotteryGoodsModalState>({
  id: 0,
  isOpen: false,
  imageUrl: '',
  name: '',
  isGot: false,
});

export const useGoodsModalAtom = () => {
  return useAtom(goodsModalAtom);
};

interface LotteryGoodsModalProps {
  layoutStyles?: typeof layoutStyles;
  utilsStyles?: typeof utilsStyles;
}

function LotteryGoodsModal({
  layoutStyles: customLayoutStyles = layoutStyles,
  utilsStyles: customUtilsStyles = utilsStyles,
}: LotteryGoodsModalProps) {
  const [goodsModal, setGoodsModal] = useGoodsModalAtom();

  const closeModal = () => {
    setGoodsModal({
      id: 0,
      isOpen: false,
      imageUrl: goodsModal.imageUrl,
      name: '',
      isGot: false,
    });
  };

  return (
    <ModalBase isOpen={goodsModal.isOpen} onClose={closeModal}>
      <ImageView src={goodsModal.imageUrl} alt={'景品'} isFreeSize />
      <div className={customLayoutStyles.modalPadding}>
        <div className={`${customUtilsStyles.mtXSmall} ${customUtilsStyles.textMedium}`}>
          <em>{goodsModal.name}</em>
        </div>
        {goodsModal.isGot && (
          <div className={customUtilsStyles.mtXSmall}>
            <LinkButton href={`/account/collection/${goodsModal.id}`} size='fullWidth' outlined>
              獲得した景品を見る
            </LinkButton>
          </div>
        )}
      </div>
    </ModalBase>
  );
}

export default LotteryGoodsModal;
